import Content from "../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import { DialogOption } from "../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/model/Dialog";

export default class DialogUtil {
    /**
     * @param {DialogOption} option 
     * @returns {Content}
     */
    static extractContentFromOption(option) {
        return option.getData().getData().content;
    }
}
